export default {"src":"/_next/static/media/ai-menu-active-icon.1fa3d7c3.svg","height":14,"width":14};